package com.sddamico.draftmachine.models

import kotlinx.serialization.Serializable

/** Frontend mirror of the jvmMain `models/LeagueModels.kt` `LeagueResponse`. */
@Serializable
data class LeagueResponse(
  val id: String,
  val name: String,
  val managerEmail: String,
)

/** Frontend mirror of the jvmMain `LeagueSummary` — participant-safe league view (no manager email). */
@Serializable
data class LeagueSummary(
  val id: String,
  val name: String,
)

/**
 * Frontend mirror of the jvmMain `CreateLeagueRequest`. The backend forces `managerEmail` to the
 * caller regardless of what is sent, so the wizard just passes the signed-in address.
 */
@Serializable
data class CreateLeagueRequest(
  val name: String,
  val managerEmail: String,
)
